import { render } from "./HeaderOperator.vue?vue&type=template&id=5e161108&scoped=true"
import script from "./HeaderOperator.vue?vue&type=script&lang=js"
export * from "./HeaderOperator.vue?vue&type=script&lang=js"

import "./HeaderOperator.vue?vue&type=style&index=0&id=5e161108&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e161108"]])

export default __exports__